module.exports = __webpack_public_path__ + "img/logo.89b3a415.png";